import {BrowserRouter, Route, Routes} from "react-router-dom";

import Profile from './components/Profile';
import Publication from './components/Publication';
import Misc from './components/Misc';
import Header from './components/Header';
import Footer from './components/Footer';
import NotFound from './components/NotFound';

import './css/custom.css';
import './css/footer.css';

function App() {
  return (
    <BrowserRouter>
      <Header />
      <div className="App">
        <header className="App-header">
          <Routes>
            <Route path="/" element={<Profile />} />
            <Route path="/publications" element={<Publication />} />
            <Route path="/misc" element={<Misc />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
          <a
            className="App-link"
            href="https://reactjs.org"
            target="_blank"
            rel="noopener noreferrer"
          >
          </a>
        </header>
      </div>
      <Footer />
    </BrowserRouter>
  );
}

export default App;
